import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (p) => `R${Number(p).toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

export function CompleteTheLook({ productId }) {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!productId) return;
    axios.get(`${API}/products/${productId}/complete-the-look`)
      .then(r => setItems(r.data || []))
      .catch(() => {});
  }, [productId]);

  if (!items.length) return null;

  return (
    <div className="border-t border-[#F0F0F0] pt-6 mt-2" data-testid="complete-the-look">
      <div className="mb-5">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-work font-semibold mb-1">
          Style Guide
        </p>
        <h3 className="font-playfair text-xl text-[#0A0A0A]">Complete the Look</h3>
      </div>

      <div className="flex gap-3">
        {items.map(item => (
          <div
            key={item.product_id}
            className="flex-1 group cursor-pointer"
            onClick={() => navigate(`/product/${item.product_id}`)}
            data-testid={`look-item-${item.product_id}`}
          >
            {/* Image */}
            <div className="relative aspect-[3/4] bg-[#F9F9F9] overflow-hidden mb-2.5">
              <img
                src={item.images?.[0] || ''}
                alt={item.name}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-black/30 flex items-end p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <button
                  className="w-full bg-white text-[#0A0A0A] text-[9px] font-bold uppercase tracking-wider py-1.5 flex items-center justify-center gap-1 font-work hover:bg-[#D4AF37] transition-colors"
                  onClick={e => { e.stopPropagation(); navigate(`/product/${item.product_id}`); }}
                  data-testid={`look-view-btn-${item.product_id}`}
                >
                  <Plus size={9} /> View Item
                </button>
              </div>
              {/* Category badge */}
              <div className="absolute top-2 left-2 bg-white/90 px-1.5 py-0.5">
                <p className="text-[8px] uppercase tracking-wider text-[#0A0A0A] font-work font-semibold">
                  {item.category}
                </p>
              </div>
            </div>

            {/* Info */}
            <p className="text-[9px] uppercase tracking-[0.2em] text-[#D4AF37] font-work font-semibold truncate">
              {item.designer}
            </p>
            <p className="text-[11px] text-[#0A0A0A] font-work leading-tight line-clamp-2 mt-0.5">
              {item.name}
            </p>
            <p className="text-[#D4AF37] text-sm font-semibold font-work mt-1">
              {fmt(item.final_price)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
